import { IFormlyConfig } from "AngularFormly";
import { cloneDeep } from "lodash";

export const vsNgFormlyType = "autoNumeric";
export const vsNgGridFormlyType = "gridAutoNumeric";

autoNumericInputConfig.$inject = ["formlyConfigProvider"];
export function autoNumericInputConfig(formlyConfigProvider: IFormlyConfig) {
  var type = {
    name: vsNgFormlyType,
    wrapper: ["bootstrapLabel", "bootstrapHasError"],
    template: require("!html-loader!./index.html").default,
  };
  formlyConfigProvider.setType(type);

  var gridType = cloneDeep(type);
  gridType.name = vsNgGridFormlyType;
  gridType.wrapper = ["bootstrapHasError"];

  formlyConfigProvider.setType(gridType);
}

export default autoNumericInputConfig;
